import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// cannot use theme since button can be rendered outside provider
const Button = styled.a `
  display: inline-flex !important;
  align-items: center !important;
  color: #fff !important;
  background-color: #3b3b3b !important;
  font-size: 12px !important;
  text-decoration: none !important!;
  padding: 10px 16px !important;
  cursor: pointer !important;
  border-radius: 4px !important;
  font-family: Lato !important;
  text-transform: none !important;
  transition: background-color 0.125s ease;

  &:visited,
  &:active {
    color: #fff !important;
    background: #3b3b3b !important;
    text-transform: none !important;
    text-decoration: none !important!;
  }

  &:hover {
    background-color: #7b7b7b !important;
  }

  svg {
    width: 32px;
    margin-right: 8px;
  }
`;
const Icon = ({ fill = '#3B3B3B' }) => (React.createElement("svg", { width: "46", height: "19", viewBox: "0 0 46 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M46 11.5C46 12.0276 45.9092 12.534 45.7424 13.0044C44.7868 16.2777 41.5 18.3846 41.5 18.3846C41.5 18.3846 38.2132 16.2777 37.2576 13.0044C37.0908 12.534 37 12.0276 37 11.5C37 11.4592 37.0005 11.4184 37.0016 11.3779C37.0005 11.3313 37 11.2845 37 11.2375H37.0075C37.1434 8.87441 39.1028 7 41.5 7C43.8972 7 45.8566 8.87441 45.9925 11.2375H46C46 11.2845 45.9995 11.3313 45.9984 11.3779C45.9995 11.4184 46 11.4592 46 11.5ZM41.5 14C42.8807 14 44 12.8807 44 11.5C44 10.1193 42.8807 9 41.5 9C40.1193 9 39 10.1193 39 11.5C39 12.8807 40.1193 14 41.5 14Z", fill: fill }),
    React.createElement("circle", { cx: "3", cy: "3", r: "3", fill: fill }),
    React.createElement("path", { d: "M13 3L24.7339 3.00016C26.805 3.00019 28.4839 4.67913 28.4839 6.7502V6.7502C28.4839 8.82128 26.8049 10.5002 24.7338 10.5002L14.2153 10.5002C12.1443 10.5002 10.4654 12.1791 10.4654 14.2501V14.2501C10.4654 16.3211 12.1443 18 14.2153 18L33 18", stroke: fill, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
const PreviewButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (React.createElement(Button, { onClick: onClick, id: "st-preview-button" },
        React.createElement(Icon, { fill: "#fff" }),
        React.createElement("span", null, t('widget.button-label'))));
};
export default PreviewButton;
